module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loadingShow),
      expression: "loadingShow"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('div', {
    staticClass: "col-md-12 financial-physical-schedule"
  }, [_c('table', {
    staticClass: "table table-condensed table-bordered"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Item")]), _vm._v(" "), _c('th', [_vm._v("Tipo")]), _vm._v(" "), _c('th', [_vm._v("Quantidade Orçada")]), _vm._v(" "), _c('th', [_vm._v("Valor Orçado")]), _vm._v(" "), _c('th', [_vm._v("Quantidade a solicitar")]), _vm._v(" "), _c('th', [_vm._v("Valor a solicitar")]), _vm._v(" "), (_vm.propsEtapa !== 'Solicitação') ? _c('th', [_vm._v("Economicidade")]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v("Quantidade disponível")]), _vm._v(" "), _c('th', [_vm._v("Valor disponível")]), _vm._v(" "), _c('th', [_vm._v("Ações")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.itensProjeto), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.Item) + " - " + _vm._s(item.Item_Descricao)), _c('br'), _vm._v("#" + _vm._s(item.Id_item) + " " + _vm._s(item.Item_Observacao))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.Item_Tipo))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(item.Qtde_orcado))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("real")(item.Valor_orcado)))]), _vm._v(" "), (item.editing === false || !item.editing) ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(item.quantidadeSolicitada))]) : _vm._e(), _vm._v(" "), (item.editing === true) ? _c('td', {
      staticClass: "text-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.quantidadeSolicitada),
        expression: "item.quantidadeSolicitada"
      }],
      staticClass: "form-control text-right",
      attrs: {
        "name": "quantidade a solicitar",
        "type": "text"
      },
      domProps: {
        "value": (item.quantidadeSolicitada)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "quantidadeSolicitada", $event.target.value)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (item.editing === false || !item.editing) ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("real")(item.valorSolicitado)))]) : _vm._e(), _vm._v(" "), (item.editing === true) ? _c('td', {
      staticClass: "text-center"
    }, [_c('money', {
      staticClass: "form-control text-right",
      attrs: {
        "name": "valor a solicitar",
        "type": "text"
      },
      model: {
        value: (item.valorSolicitado),
        callback: function($$v) {
          _vm.$set(item, "valorSolicitado", $$v)
        },
        expression: "item.valorSolicitado"
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.propsEtapa !== 'Solicitação') ? _c('td', {
      staticClass: "text-center"
    }, [_c('label', {
      staticClass: "checkbox-inline new-control new-control-checkbox",
      staticStyle: {
        "margin-bottom": "10px"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.Economicidade),
        expression: "item.Economicidade"
      }],
      attrs: {
        "disabled": _vm.propsEtapa !== 'Análise' || item.editing === false || _vm._.isUndefined(item.editing),
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(item.Economicidade) ? _vm._i(item.Economicidade, null) > -1 : (item.Economicidade)
      },
      on: {
        "change": [function($event) {
          var $$a = item.Economicidade,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(item, "Economicidade", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(item, "Economicidade", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(item, "Economicidade", $$c)
          }
        }, function($event) {
          return _vm.marcaItem(item)
        }]
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "new-control-indicator"
    })])]) : _vm._e(), _vm._v(" "), (_vm.propsEtapa !== 'Solicitação') ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(item.Qtde_saldo))]) : _vm._e(), _vm._v(" "), (_vm.propsEtapa === 'Solicitação') ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(item.Qtde_saldo - (item.quantidadeSolicitada ? item.quantidadeSolicitada : 0)))]) : _vm._e(), _vm._v(" "), (_vm.propsEtapa !== 'Solicitação') ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("real")(item.Valor_saldo)))]) : _vm._e(), _vm._v(" "), (_vm.propsEtapa === 'Solicitação') ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("real")(item.Valor_saldo - (item.valorSolicitado ? item.valorSolicitado : 0))))]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(item.editing === false || !item.editing) ? _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.propsEtapa !== 'Autorização' && item.Valor_saldo > 0),
        expression: "propsEtapa !== 'Autorização' && item.Valor_saldo > 0"
      }],
      staticClass: "fa fa-edit",
      staticStyle: {
        "margin-left": "5px"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.editItem(item, 1)
        }
      }
    }) : _vm._e(), _vm._v(" "), (item.editing === false && _vm.propsEtapa === 'Solicitação' && item.quantidadeSolicitada > 0) ? _c('i', {
      staticClass: "fa fa-times",
      staticStyle: {
        "color": "red",
        "margin-left": "5px",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.apagaItem(item)
        }
      }
    }) : _vm._e(), _vm._v(" "), (item.editing === true) ? _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.propsEtapa !== 'Autorização'),
        expression: "propsEtapa !== 'Autorização'"
      }],
      staticClass: "fa fa-check",
      staticStyle: {
        "color": "green",
        "margin-left": "5px",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.editItem(item, 2)
        }
      }
    }) : _vm._e()])])
  }), 0), _vm._v(" "), _c('tfoot', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "border-right": "none"
    },
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("Valor total de recursos contratados: ")]), _vm._v(" "), _c('td', {
    staticClass: "text-right",
    staticStyle: {
      "border-left": "none"
    },
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm._f("real")(_vm.totais.valor_total_contratado)))]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-right": "none"
    },
    attrs: {
      "colspan": "5",
      "bgcolor": "#F0F8FF"
    }
  }, [_vm._v("Valor total da solicitação:\t")]), _vm._v(" "), _c('td', {
    staticClass: "text-right",
    staticStyle: {
      "border-left": "none"
    },
    attrs: {
      "colspan": "4",
      "bgcolor": "#F0F8FF"
    }
  }, [_vm._v(_vm._s(_vm._f("real")(_vm.total)))]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-right": "none"
    },
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("Saldo restante do projeto:\t")]), _vm._v(" "), _c('td', {
    staticClass: "text-right",
    staticStyle: {
      "border-left": "none"
    },
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm._f("real")(_vm.totais.valor_total_contratado - _vm.total)))]), _vm._v(" "), _c('td')])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Cronograma Físico-Financeiro")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-737e928f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/solicitacoes/modulos/cronograma-solicitacao-contrapartida.vue
// module id = 1948
// module chunks = 2